// Accreditation 2 — "Ranking & Recognitions" logo strip + carousel.
// Each logo is a single baked image (logo + caption in one upload); there is
// NO separate caption text field. Heading + Sub-heading are optional.
// PRD: min 2 / max 10 logos, 4 per view, carousel arrows only when count > 4.

export const ACCREDITATION_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_logo: "",
    meta_alt_image: "Accreditation logo",
    meta_priority: 1,
    meta_status: true,
  },

  ACCREDITATION_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Heading (optional)",
      value: "Ranking and Recognitions",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter heading",
      required: false,
      defaultValue: "Ranking and Recognitions",
    },
    {
      fieldName: "title_text_color",
      label: "Heading Text Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter heading text color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "sub_title",
      label: "Sub Heading (optional)",
      value: "Industry-aligned curriculum, at par with on-campus programs.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter sub heading",
      required: false,
      defaultValue: "Industry-aligned curriculum, at par with on-campus programs.",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Heading Text Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub heading text color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "status",
      label: "Accreditation Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Accreditation",
      defaultValue: false,
    },
    // Carousel arrows render as built-in maroon circles by default. Upload here
    // only to override them. Arrows appear only when there are more than 4 logos.
    {
      fieldName: "left_navigation_icon",
      label: "Carousel Left Arrow (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload left arrow icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left Arrow Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left arrow",
      required: false,
      defaultValue: "Previous",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Carousel Right Arrow (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload right arrow icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right Arrow Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right arrow",
      required: false,
      defaultValue: "Next",
    },
  ],

  METADATA_TITLES: {
    metadata: "Accreditation Logos (min 2, max 10)",
  },

  // Min 2 / Max 10 logos (PRD). Enforced in the admin: "Add New Row" is capped
  // at 10 and Save is blocked below 2 / above 10 (see TableFormatter + Form1 hook).
  METADATA_LIMITS: {
    metadata: { min: 2, max: 10 },
  },

  METADATA_FIELDS: [
    {
      header: "Logo (with caption baked in)",
      fieldName: "meta_logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Logo",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable this item",
      defaultValue: true,
    },
  ],
};
